import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { Step } from '../../types/Step';
import { UserSettingsCollapseKeys } from '../../types/User';
import { StepItem } from './StepItem';
import { columns } from './StepItemStyles';
import AccordionSection from '../AccordionSection';

interface StepsTableProps {
  steps: Step[];
  handleStepToggle: (step: Step, action: 'complete' | 'start') => void;
  editPermitted: boolean;
  taskUuid: string;
}

const StepTable = ({ steps, handleStepToggle, editPermitted, taskUuid }: StepsTableProps) => {
  const sortedSteps = _.sortBy(steps, 'order');

  return (
    <AccordionSection title="Steps" collapseId={UserSettingsCollapseKeys.TASK_ITEM_STEPS}>
      <TableContainer sx={{ pt: 1 }} component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Step Name</TableCell>
              <TableCell sx={columns}>Start</TableCell>
              <TableCell sx={columns} width={'100%'}>
                Complete
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedSteps.map((step) => (
              <TableRow key={step.uuid}>
                <StepItem step={step} handleStepToggle={handleStepToggle} editPermitted={editPermitted} taskUuid={taskUuid} />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </AccordionSection>
  );
};
export default StepTable;
